import React, { useEffect } from "react";
import { useLoginModal } from "../../context/LoginModalContext";

const LoginPage: React.FC = () => {
  const { openLoginModal } = useLoginModal();

  useEffect(() => {
    openLoginModal();
  }, [openLoginModal]);

  // The login form is now rendered as a modal by Layout.
  // This page opens the modal for direct /login URL visits.
  return <div className="min-h-[70vh]" />;
};

export default LoginPage;
